import React, { FC } from 'react';
import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';
import { Maybe } from '@oberoninternal/travelbase-ds/entities/Maybe';
import { OrderSummaryFragment, OrderSummaryItemFragment } from '../generated/graphql';
import { Box, Flex } from '@rebass/grid';
import { FormattedMessage } from 'react-intl';
import SummaryBar from './SummaryBar';
import { useTenantContext } from '../context/TenantContext';
import TextButton from '@oberoninternal/travelbase-ds/components/action/TextButton';
import { useRouter } from 'next/router';
import TitleWrapper from './designsystem/TitleWrapper';
import styled from 'styled-components';
import { Locale } from '../entities/Locale';

interface Props {
    orderItem: Maybe<OrderSummaryFragment | OrderSummaryItemFragment>;
    setLeftReview: (val: boolean | null) => void;
    isAnonymous?: boolean;
    pushUrl: string;
    pathName: string;
    locale: string | undefined;
}
const ReviewDone: FC<React.PropsWithChildren<Props>> = ({
    orderItem,
    setLeftReview,
    isAnonymous,
    pushUrl,
    pathName,
    locale,
}) => {
    const { brandConfig } = useTenantContext();
    const { push } = useRouter();

    return (
        <Flex flexDirection={['column', null, 'row']} justifyContent="space-between">
            <Box order={1} mr={[null, null, 5, 8]}>
                <StyledTitleWrapper title={<FormattedMessage defaultMessage="Bedankt voor je beoordeling" />} />
                <Description>
                    <FormattedMessage
                        defaultMessage="We hebben je beoordeling gepubliceerd op de website. Je kunt deze {here} bekijken."
                        values={{
                            here: (
                                // we've left a review, shown a "thank you" part, so now we can show the review when the user wants to
                                <TextButton
                                    showBorderAlways
                                    onClick={() =>
                                        isAnonymous
                                            ? push(pushUrl, {
                                                  pathname: pathName,
                                              })
                                            : setLeftReview(null)
                                    }
                                >
                                    <FormattedMessage defaultMessage="hier" />
                                </TextButton>
                            ),
                        }}
                    />
                    <br />
                    <br />
                    <FormattedMessage defaultMessage="We zien je graag in de toekomst terug op ons mooie eiland!" />
                    <br />
                    <br />
                    {brandConfig?.surveyUrl?.[locale as Locale] && (
                        <>
                            <b>
                                <FormattedMessage defaultMessage="Win een weekend op Texel" />
                            </b>
                            <br />
                            <FormattedMessage defaultMessage="De ondernemers op het eiland willen hun dienstverlening graag continu verbeteren. Jouw mening over Texel als vakantiebestemming is daarbij heel belangrijk." />
                            <br />
                            <br />
                            <FormattedMessage defaultMessage="Met het invullen van een korte enquête deel je jouw ervaringen tijdens je verblijf op het eiland. Bijvoorbeeld jouw ervaring met het aanbod en de service in de horeca, de winkels en de musea op Texel." />
                            <br />
                            <br />
                            <FormattedMessage defaultMessage="Onder de inzenders verloten we jaarlijks op 1 december een verblijf op Texel (geldig in het volgende kalenderjaar) in de vorm van een cadeaubon van € 500, te besteden bij een telefonische boeking via VVV Texel" />
                            <br />
                            <a href={brandConfig.surveyUrl[locale as Locale]} target="_blank" rel="noreferrer">
                                <FormattedMessage defaultMessage="Jouw ervaringen op Texel" />
                            </a>
                        </>
                    )}
                </Description>
            </Box>
            <Box order={1} mb={6} ml={[3, null, 4]} width="30%" className="gt-m">
                <SummaryBar data={orderItem} showOnMobile hidePrices />
            </Box>
        </Flex>
    );
};
export default ReviewDone;

const StyledTitleWrapper = styled(TitleWrapper)`
    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.s}) {
        text-align: unset;
    }
`;

const Description = styled(Body)`
    margin-top: 1.9rem;

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.m}) {
        margin-top: 2.7rem;
    }
`;
